<template>
  <div class="order editFinancial">
    <head-panel title="财务管理" subtitle="FINANCIAL MANAGEMENT" :exportUrl="financial.editDown"></head-panel>
    <div class="oprPanel">
      <h3 class="subLabel">财务编辑</h3>
      <div class="selectBox clearfix">
        <ny-select
          :data="financial.editTypeMenu"
          v-model="financial.curEditType"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userType"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <ny-select
          :data="financial.editUserMenu"
          v-model="financial.curEditUser"
          :keyValue="['value', 'name']"
          @change="changeSelect"
          type="userMenu"
          placeholder="请选择"
          class="advertiseSelect input_sm"
        ></ny-select>
        <el-input class="searchBox" icon="search" v-model="accountName" placeholder="请输入账号名称"></el-input>
        <el-input class="searchBox" icon="search" v-model="adverName" placeholder="请输入广告主名称"></el-input>
        <el-button class="oprSuccess mr55" @click="searchData">搜索</el-button>
      </div>
      <div class="adTable">
        <ny-table
          class="tableBox mt20"
          :page="financial.editPage"
          :pageFalse="true"
          @size-change="changePageSize"
          @current-change="changePageSize"
          v-loading="loading"
        >
          <template slot v-if="financial.editPage.data.length>0">
            <el-table-column fixed="right" label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'add')"
                  type="primary"
                  size="small"
                  class="comButton ssButton"
                >加款</el-button>
                <el-button
                  @click="handlePrice(scope.$index, scope.row, 'minus')"
                  type="primary"
                  size="small"
                  class="comButton ssButton is-refund"
                >退款</el-button>
                <el-button
                  @click="handleRebate(scope.$index, scope.row)"
                  type="primary"
                  size="small"
                  class="is-edit"
                  v-if="false"
                >返货</el-button>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
    </div>
    <custom-dialog :customDialog="premiumDialog" class="priceCus">
      <!-- 加款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :money="money"
          :type="addPrice"
          :platform="platform"
          :data="addMenu"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :errorShow="errorShow.add"
          :committing="committing"
          :setMax="setMax"
        ></priceCus>
      </div>
    </custom-dialog>
    <custom-dialog :customDialog="refundDialog" class="priceCus">
      <!-- 退款-->
      <div slot="dialogCon">
        <priceCus
          :rowId="rowId"
          :type="refund"
          :money="money"
          :data="refundMenu"
          :platform="platform"
          @surePrice="surePrice"
          @cancelPrice="cancelPrice"
          :errorShow="errorShow.refund"
          :committing="committing"
          :setMax="setMax"
        ></priceCus>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import { headPanel, NySelect, NyTable, customDialog, priceCus } from '@/global/components';
import { mapGetters } from 'vuex';
import { post } from '@/manager/http/index'
export default {
  name: 'advertiser',
  data () {
    return {
      adver: {
        value: ''
      },
      money: {
        addCash: '',
        addGoods: '',
        cash: '',
        goods: '',
        type: 1
      },
      rowId: '',
      platform: '',
      downloadExc: '',
      adverName: '',
      accountName: '',
      setMax: '',
      addMenu: [
      ],
      refundMenu: [
      ],
      addPrice: {
        title: '加款金额',
        type: 'add',
        cashType: 1
      },
      refund: {
        title: '退款金额',
        type: 'refund',
        cashType: 1
      },
      errorShow: {
        add: false,
        refund: false
      },
      page: {
        headers: {
          name: '财务',
          adName: '广告名称',
          id: 'ID'
        },
        data: [
          {
            name: '1345',
            adName: '创意',
            id: '12'
          },
          {
            name: '1345',
            adName: '创意',
            id: '11'
          }
        ]
      },
      loading: false,
      premiumDialog: {// 加款
        visible: false,
        isClickModal: false
      },
      refundDialog: {// 退款
        visible: false,
        isClickModal: false
      },
      committing: false // 提交状态
    };
  },
  computed: {
    ...mapGetters({
      financial: 'finance/financial',
      userid: 'login/userid'
    })
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.platform = this.$router.currentRoute.meta.platform
      await this.$store.dispatch('finance/getEditTypeMenu')
      await this.getUserMenu({ value: this.financial.curEditType })
      this.getFinDetailsInfo()
    },
    getUserMenu ({ startTime, endTime, value } = {}) {
      this.$store.dispatch('finance/getEditUserMenu', {
        userType: value
      })
    },
    getFinDetailsInfo ({ currentPage, pageSize } = {}) {
      this.$store.dispatch('finance/getEditFinTable', {
        userType: this.financial.curEditType,
        currentPage,
        pageSize,
        userId: this.financial.curEditUser,
        accountName: this.accountName,
        userName: this.adverName
      })
    },
    changeSelect ({ value, type }) {
      if (type === 'userType') {
        this.getUserMenu({ value })
      }
    },
    changePageSize ({ currentPage, pageSize } = {}) {
      this.getFinDetailsInfo({ currentPage, pageSize })
    },
    searchData () {
      this.financial.editPage.resetData()
      this.getFinDetailsInfo()
    },
    handlePrice (index, row, handleType) {
      this.rowId = row;
      if (handleType === 'add') {
        post('/admin/finance/financebalance', {
          user_type: this.rowId.user_type,
          user_id: this.rowId.user_id
        }).then(res => {
          if (res.code === 1) {
            this.money.addCash = parseFloat(res.data.cash_balance)
            this.money.addGoods = res.data.rebate_balance
            // this.setMax = res.data.data.balance
            if (handleType === 'add') {
              this.setMax = parseFloat(res.data.cash_balance)
            }
          }
        })
        this.premiumDialog.visible = true;
      } else {
        this.refundDialog.visible = true;
      }
      post('/admin/finance/balance', {
        user_type: this.rowId.balance_type,
        account_id: this.rowId.user_id
      }).then(res => {
        if (res.code === 1) {
          this.money.cash = res.data.data.cash_balance
          this.money.goods = res.data.data.rebate_balance
          if (handleType !== 'add') {
            this.setMax = res.data.data.cash_balance
          }
        }
      })
    },
    surePrice ({ handleType, form }) {
      this.committing = true
      let data = {}
      let self = this
      let api = handleType === 'add' ? '/admin/finance/financebalance' : '/admin/finance/balance'
      if (handleType === 'add') {
        data.user_id = this.rowId.user_id
        data.user_type = this.rowId.user_type
      } else {
        data.account_id = this.rowId.user_id
        data.user_type = this.rowId.balance_type
      }
      post(api, data).then(res => {
        if (res.code === 1) {
          let balance = handleType === 'add' ? parseFloat(res.data.cash_balance) : res.data.data.cash_balance
          if (balance >= parseInt(form.price)) {
            self.errorShow.add = false
            self.submitMoney({ handleType, form })
          } else {
            self.errorShow.add = true
          }
        }
      })
    },
    submitMoney ({ handleType, form }) {
      let self = this
      let params = {}
      params.user_id = self.rowId.user_id
      params.p_id = self.userid
      params.money = form.price
      params.ext = form.remark
      params.user_type = self.rowId.user_type
      params.balance_type = 1
      params.name = self.rowId.user_name
      params.type = handleType === 'add' ? 1 : 2
      params.account_id = self.userid
      post('/admin/finance/money', params).then(res => {
        self.committing = false
        if (res.code === 1) {
          if (handleType === 'add') {
            self.premiumDialog.visible = false;
            self.$message('加款成功')
          } else {
            self.refundDialog.visible = false;
            self.$message('退款成功')
          }
          self.getFinDetailsInfo()
        } else {
          self.$message.error(res.msg)
        }
      }).catch(() => {
        self.committing = false
      })
    },
    cancelPrice ({ handleType }) {
      if (handleType === 'add') {
        this.premiumDialog.visible = false;
      } else {
        this.refundDialog.visible = false;
      }
    },
    handleRebate (index, row) {
      this.$router.push({ name: 'rebateFinancial', params: { id: row.id } })
    }
  },
  components: {
    headPanel,
    NySelect,
    NyTable,
    customDialog,
    priceCus
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.editFinancial {
  .ml20 {
    margin-left: 20px;
  }
  .add_order {
    width: 114px;
    b {
      float: left;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0px;
    }
  }
  .el-date-editor {
    margin-right: 20px;
  }
  .selectBox {
    margin-top: 20px;
    .el-select {
      width: 230px;
    }
  }
  .priceCus {
    .el-dialog {
      width: 500px;
    }
  }
}
</style>
